import { httpClient } from '../httpClient';

export const dataflowRegulatoryApi = {
  // SAMA Approval
  listSAMAApprovals: (params) =>
    httpClient.get('/dataflow/sama', { params }),

  initiateSAMAApproval: (data) =>
    httpClient.post('/dataflow/sama', data),

  approveSAMA: (approvalId, data) =>
    httpClient.put(`/dataflow/sama/${approvalId}/approve`, data),

  rejectSAMA: (approvalId, data) =>
    httpClient.put(`/dataflow/sama/${approvalId}/reject`, data),

  // NCA DCC Assessment
  getNCAAssessment: (flowId) =>
    httpClient.get(`/dataflow/nca-dcc/${flowId}`),

  saveNCAAssessment: (data) =>
    httpClient.post('/dataflow/nca-dcc', data),

  // BCR Management
  listBCRs: (params) =>
    httpClient.get('/dataflow/bcr', { params }),

  createBCR: (data) =>
    httpClient.post('/dataflow/bcr', data),

  updateBCR: (bcrId, data) =>
    httpClient.put(`/dataflow/bcr/${bcrId}`, data),

  updateBCRStatus: (bcrId, data) =>
    httpClient.put(`/dataflow/bcr/${bcrId}/status`, data),

  getExpiringBCRs: (params) =>
    httpClient.get('/dataflow/bcr/expiring', { params }),

  exportBCR: (bcrId, lang) =>
    httpClient.get(`/dataflow/bcr/${bcrId}/export`, {
      params: { lang },
      responseType: 'blob',
    }),

  // Data Residency
  listResidencyViolations: () =>
    httpClient.get('/dataflow/residency/violations'),

  validateResidency: (flowId) =>
    httpClient.post(`/dataflow/residency/validate/${flowId}`),
};
